import { __spreadArray } from './__helpers/tslib/tslib.es6.js';

var EventsListeners = /** @class */ (function () {
    function EventsListeners() {
        this.listeners = {};
    }
    EventsListeners.prototype.set = function (event, subscriptions) {
        this.listeners[event] = subscriptions;
    };
    EventsListeners.prototype.get = function (event) {
        var subscriptions = this.listeners[event] || [];
        return subscriptions;
    };
    EventsListeners.prototype.clear = function () {
        this.listeners = {};
    };
    EventsListeners.prototype.has = function (event) {
        return typeof this.listeners[event] !== "undefined";
    };
    EventsListeners.prototype.delete = function (event) {
        delete this.listeners[event];
    };
    EventsListeners.prototype.getByNamespace = function (namespace) {
        var events = {};
        for (var event_1 in this.listeners) {
            if (event_1.startsWith(namespace)) {
                events[event_1] = this.listeners[event_1];
            }
        }
        return events;
    };
    EventsListeners.prototype.getByNamespaceArray = function (namespace) {
        var eventSubscriptions = [];
        for (var event_2 in this.listeners) {
            if (event_2.startsWith(namespace)) {
                eventSubscriptions = __spreadArray(__spreadArray([], eventSubscriptions, true), this.listeners[event_2], true);
            }
        }
        return eventSubscriptions;
    };
    EventsListeners.prototype.deleteByNamespace = function (namespace) {
        for (var event_3 in this.listeners) {
            if (event_3.startsWith(namespace)) {
                delete this.listeners[event_3];
            }
        }
    };
    return EventsListeners;
}());

export { EventsListeners as default };
